var _polygon, _path, _path2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgInsolite = function SvgInsolite(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    x: "0px",
    y: "0px",
    viewBox: "-459 265.4 39.3 31.6",
    style: {
      enableBackground: "new -459 265.4 39.3 31.6"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "-446,272.8 -444.8,275.1 -444.4,272.6 -441.8,272.2 -444.1,271 -443.7,268.4 -445.6,270.2 -447.9,269  -446.7,271.4 -448.6,273.2 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-424.7,283.5l-11.5-4.8c-2-0.8-4.3-0.8-6.3,0l-11.5,4.8c-3,1.3-5,4.2-5,7.5v6h16.4v-8.1c0-1.8,1.5-3.3,3.3-3.3 c1.8,0,3.3,1.5,3.3,3.3v8.1h16.4v-6C-419.7,287.7-421.7,284.8-424.7,283.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-428.2,271.4c-1.6,1.6-4.1,1.6-5.7,0s-1.6-4.1,0-5.7c0.1-0.1,0.3-0.2,0.4-0.3c-1,0.2-2,0.6-2.8,1.4 c-1.9,1.9-1.9,5.1,0,7c1.9,1.9,5.1,1.9,7,0c0.8-0.8,1.2-1.8,1.4-2.8C-428,271.2-428.1,271.3-428.2,271.4z"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInsolite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/insolite.b6fbaadd.svg";
export { ForwardRef as ReactComponent };